/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserRequest,
    UserRequestFromJSON,
    UserRequestFromJSONTyped,
    UserRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface AuditRecordRequest
 */
export interface AuditRecordRequest {
    /**
     * 
     * @type {Date}
     * @memberof AuditRecordRequest
     */
    updatedDate?: Date;
    /**
     * 
     * @type {UserRequest}
     * @memberof AuditRecordRequest
     */
    updatedBy?: UserRequest;
}

export function AuditRecordRequestFromJSON(json: any): AuditRecordRequest {
    return AuditRecordRequestFromJSONTyped(json, false);
}

export function AuditRecordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditRecordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updatedDate': !exists(json, 'updatedDate') ? undefined : (new Date(json['updatedDate'])),
        'updatedBy': !exists(json, 'updatedBy') ? undefined : UserRequestFromJSON(json['updatedBy']),
    };
}

export function AuditRecordRequestToJSON(value?: AuditRecordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updatedDate': value.updatedDate === undefined ? undefined : (value.updatedDate.toISOString()),
        'updatedBy': UserRequestToJSON(value.updatedBy),
    };
}


